import { Input } from "@babackapp/ui/components/input";
import { ALL_STATUSES, type EmbedFilters } from "./storefront-embed-row-filter";

const SELECT_CLASS = "h-8 rounded-md border bg-background px-2 text-sm";

const STATUS_OPTIONS = [
  { value: ALL_STATUSES, label: "Tous les statuts" },
  { value: "active", label: "Embed actif" },
  { value: "inactive", label: "Embed inactif" },
  { value: "unknown", label: "Statut inconnu" },
];

export function StorefrontEmbedFilters({
  filters,
  onChange,
}: {
  filters: EmbedFilters;
  onChange: (filters: EmbedFilters) => void;
}) {
  const toggles = [
    { key: "readyOnly", label: "Prêts à nettoyer uniquement" },
    { key: "includeTest", label: "Inclure les shops de test" },
    { key: "includeInactive", label: "Inclure les shops inactifs" },
  ] as const;

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Input
        placeholder="Rechercher un shop ou un domaine"
        value={filters.search}
        onChange={(event) =>
          onChange({ ...filters, search: event.target.value })
        }
        className="h-8 w-64"
      />
      <select
        value={filters.status}
        onChange={(event) =>
          onChange({ ...filters, status: event.target.value })
        }
        className={SELECT_CLASS}
      >
        {STATUS_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {toggles.map(({ key, label }) => (
        <label key={key} className="flex items-center gap-1.5 text-sm">
          <input
            type="checkbox"
            checked={filters[key]}
            onChange={(event) =>
              onChange({ ...filters, [key]: event.target.checked })
            }
          />
          {label}
        </label>
      ))}
    </div>
  );
}
